@if (guide()) {
	@let staticOneDesc =
		'Find the right ' +
		subject() +
		' courses and degrees with our undergraduate course search.';
	@let staticTwoTitle =
		rankingsSlug()
			? 'Best universities for ' + subject()
			: 'Discover best universities';
	@let staticTwoDesc =
		rankingsSlug()
			? 'The top universities for ' +
				subject() +
				' ranked using factors that matter to you - check them out!'
			: 'Our university rankings focus on the areas we know matter to you - check them out!';
	@let staticTwoLink =
		rankingsSlug() ? '/rankings/subjects/' + rankingsSlug() : '/rankings/subjects';

	<uc-article-container
		[loadingAnimation]="loadingHtml()"
		[loadingArticle]="loadingGuide()"
		[article]="guide()"
		[articleCategoryUrl]="guideCategoryUrl()"
		[articleCategory]="guideCategory()"
		[url]="url()"
		[guideCategoryLongName]="guideCategoryLongName()"
	/>

	<div id="ad_stop">
		<!-- snigel desktop -->
		<div class="container hidden lg:block">
			<div class="adngin !mb-0">
				<div
					id="adngin-incontent_1_dskt-0"
					class="mx-auto incontent_1_dskt-0"
				></div>
			</div>
		</div>

		<div class="container">
			<div class="border-t lg:border-0">
				@if (guideCategory() === 'subject') {
					<div class="divider">
						<h2 class="secondary-header">Explore courses & rankings</h2>
						<div class="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-16">
							<uc-static-card
								[title]="'Search ' + subject() + ' degrees and courses'"
								[desc]="staticOneDesc"
								image="/assets/img/Course_Search_Image_CTA_Web_01.png"
								[link]="'/courses/degrees/' + courseSearchSlug()"
								[external]="false"
								customHeight="lg:h-72"
							/>
							<uc-static-card
								[title]="staticTwoTitle"
								[desc]="staticTwoDesc"
								image="/assets/img/Rankings_Top_100_CTA.png"
								[link]="staticTwoLink"
								[external]="false"
								customHeight="lg:h-72"
							/>
						</div>
					</div>
				} @else {
					<uc-engage-card-cta
						backgroundImageClass="bg-cta-subject-rankings"
						[border]="false"
						icon="uc_sparkles.svg"
						iconText="SUBJECT RANKINGS"
						[ugSearchOrderPosition]="null"
						[cleSearchOrderPosition]="null"
						cardTitle="Discover top universities"
						link="/rankings/subjects"
						description="Our university rankings focus on the areas we know matter to you - check them out!"
					>
						<a
							class="inline-block w-full md:w-auto blue-button"
							routerLink="/rankings/subjects"
							>See Rankings</a
						>
					</uc-engage-card-cta>
				}
			</div>
		</div>

		<uc-recommended-unis-carousel />
	</div>
}

<uc-sticky-lead-bar-renderer leadType="BOOK_EVENT" colorScheme="ROSE" />
